import { decode } from 'blurhash';
import { useEffect, useRef } from 'react';

import { Props } from './BlurhashCanvas.types';

const BlurhashCanvas = ({ blurhash, width, height }: Props) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (!canvasRef.current) return;
    if (!blurhash || blurhash.length < 6) return;

    const pixels = decode(blurhash, width, height);
    const ctx = canvasRef.current.getContext('2d');
    if (!ctx) return;

    const imageData = ctx.createImageData(width, height);
    imageData.data.set(pixels);
    ctx.putImageData(imageData, 0, 0);
  }, [blurhash, width, height]);

  return <canvas ref={canvasRef} width={width} height={height} />;
};

export default BlurhashCanvas;
